<script>
import appConfig from "@/app.config";
// layout
import Layout from "../../layouts/auth";
export default {
  page: {
    title: "404 Error Page",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout },
}
</script>
<template>
<Layout>
      <div class="row justify-content-center align-items-center h-100">
        <div class="col-12">
          <div class="text-center">
            <h1 class="display-2 fw-medium">
              4<i class="bx bx-buoy bx-spin text-primary display-3"></i>4
            </h1>
            <h4 class="text-uppercase">Sorry, page not found</h4>
            <div class="mt-4 text-center">
              <router-link tag="a" class="btn btn-primary" to="/">Back to Dashboard</router-link>
            </div>
            <img src="@/assets/images/error-img.png" alt class="img-fluid" style="max-width:480px;"/>
          </div>
        </div>
      </div>
</Layout>
</template>

